export const SET_REPORT_LIST = 'SET_REPORT_LIST';
export const SET_CONNECTION_LIST = "SET_CONNECTION_LIST";
export const SET_SCHEDULE_LIST = "SET_SCHEDULE_LIST";
export const SET_FTP_LIST = "SET_FTP_LIST";